import { factorLabel, factorInfo } from '@/lib/clientScore';
import type { StockFactors } from '@/lib/compute';

interface Props {
  factorKey: keyof StockFactors;
  enabled: boolean;
  onToggle: () => void;
  highlighted: boolean;
  onHighlight: () => void;
  infoOpen: boolean;
  onToggleInfo: () => void;
}

export function FactorRow({
  factorKey,
  enabled,
  onToggle,
  highlighted,
  onHighlight,
  infoOpen,
  onToggleInfo,
}: Props) {
  const info = factorInfo(factorKey);
  return (
    <div className="relative">
      <div className="flex items-center gap-1.5 py-0.5">
        <button onClick={onToggle} className="flex items-center gap-1.5 cursor-pointer">
          <span
            className={`w-2 h-2 rounded-sm border flex items-center justify-center text-[6px]
                       ${enabled ? 'bg-blue-500 border-blue-500 text-white' : 'border-[#334155]'}`}
          >
            {enabled && '✓'}
          </span>
        </button>
        <span
          className={`text-[10px] cursor-help hover:underline ${
            highlighted
              ? 'text-amber-400 font-semibold'
              : enabled
              ? 'text-[#e2e8f0]'
              : 'text-white'
          }`}
          onClick={() => {
            onToggleInfo();
            onHighlight();
          }}
        >
          {factorLabel(factorKey)}
          {highlighted ? ' ✨' : ''}
        </span>
      </div>
      {infoOpen && info && (
        <div
          className="ml-4 mb-2 mt-1 p-2 rounded text-[9px] leading-relaxed"
          style={{ background: '#0f172a', border: '1px solid #334155' }}
        >
          <div className="text-blue-400 font-semibold mb-1">{info.formula}</div>
          <div className="text-[#94a3b8]">{info.description}</div>
          {highlighted && (
            <div className="text-amber-400 text-[8px] mt-1 font-semibold">Top 10 highlighted on 3D chart</div>
          )}
        </div>
      )}
    </div>
  );
}
